import styled from 'styled-components';
import { ReactComponent as Ball } from '../../Assets/soccer_ball.svg';
import mainColors from '../main-colors';
import sizeStandards from '../size-standards';

// const Loader = styled.div`
//   border: 8px solid ${mainColors.dark_background};
//   border-radius: 50%;
//   border-top: 8px solid ${mainColors.main_color};
//   width: 60px;
//   height: 60px;
//   box-shadow: inset 0px 0px 20px 5px ${mainColors.main_color};
//   animation: spin 1s linear infinite;

//   @keyframes spin {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `;

const BackgroundWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${mainColors.main_color};
  z-index: 9;
`;

const StyledBall = styled(Ball)`
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  fill: ${mainColors.main_color_rgba(0.8)};
  stroke: ${mainColors.dark_background};
  filter: drop-shadow(0px 0px 9px ${mainColors.dark_background});

  @media screen and (max-width: ${sizeStandards.screen.MD}px) {
    width: 80px;
    height: 80px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Spinner = () => (
  <BackgroundWrapper>
    <StyledBall />
  </BackgroundWrapper>
);

export default Spinner;
